import React from "react";
import { AccentInfo } from "../../../StyledComponents";
import {
  TimelineChangeList,
  TimelineChangeRow,
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const formatEditedValue = (detail, value, emptyLabel = "none") => {
  if (value === 'Y') return 'YES'
  if (value === 'N') return 'NO'
  if (!value) return <AccentInfo style={{fontWeight: '400', margin: '0'}}>{emptyLabel}</AccentInfo>
  if (detail.field.includes('Rate') || detail.field.includes('%')) return `${value}%`
  if (detail.field.includes('Price') || detail.field.includes('Amount') || detail.field.includes('Value')) return `$${value}`
  return value
}

const DiscrepancyEditedOrRejected = ({ milestone }) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    {(milestone.activeDiscrepancies && milestone.activeDiscrepancies > 0 ) &&
      <TimelineSectionTitle>
        {milestone.activeDiscrepancies} {milestone.activeDiscrepancies === 1 ? `Discrepancy remaining` : `Discrepancies remaining`}
      </TimelineSectionTitle>
    }
    {milestone.milestone === 'Internal Records Updated' &&
      <TimelineSectionTitle>The Mortgage is now waiting for the Public Records to update</TimelineSectionTitle>
    }
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">updated by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    <TimelineSection>
      <TimelineSectionTitle>
        {milestone.milestone === 'Internal Records Updated' ? `"${milestone.details.label}" changed` : `Internal record changed`}
      </TimelineSectionTitle>
      <TimelineChangeList>
        <TimelineChangeRow>
          <span className="timeline-change-label">from:</span>
          <span className="timeline-change-value">{formatEditedValue(milestone.details, milestone.details.old)}</span>
        </TimelineChangeRow>
        <TimelineChangeRow>
          <span className="timeline-change-label">to:</span>
          <span className="timeline-change-value">{formatEditedValue(milestone.details, milestone.details.new, "-none-")}</span>
        </TimelineChangeRow>
      </TimelineChangeList>
    </TimelineSection>
  </TimelineContent>
)

export default DiscrepancyEditedOrRejected
